import { useState, useCallback } from "react";
import { auth } from "firebase/app";
import { toastr } from "react-redux-toastr";

import { getGapi } from "../../api/googleDrive";
import { useDropbox } from "../providers/Dropbox";

export const useSignOut = () => {
  const [isPending, setIsPending] = useState(false);
  const { isSignIn: isSignInDropbox, signOut: signOutDropbox } = useDropbox();
  /* sign out from accounts [firebase, gapi, dropbox] */
  const signOut = useCallback(() => {
    setIsPending(true);
    const gapi = getGapi();
    const authInstance = gapi.auth2.getAuthInstance();

    auth().signOut()
      .then(() => {
        /*
        * Michael Jackson - creator of react-router
        * https://github.com/ReactTraining/history/issues/567#issuecomment-386323573
        * */
        window.location.reload();
        window.location.replace("/");
      })
      .catch(({ message }) => {
        toastr.error("Something went wrong", message);

        setIsPending(true);
      });

    if (authInstance.isSignedIn.get()) {
      authInstance.signOut()
        .catch((error: Error) => {
          console.error(error);
        });
    }

    if (isSignInDropbox) {
      signOutDropbox();
    }
  }, [isSignInDropbox, signOutDropbox]);

  return ({ isPending, signOut });
};
